import React from "react";


export default function Photos(props){
    if(props.photos){
        return (<section className="Photos">
      
        <div className="row">
            {props.photos.map((photo, index)=>{ 
                return(<div className="col-3 mb-3" key={index}>
                    <a href={photo.src.original} target="_blank" rel="noreferrer">
                    <img src={photo.src.landscape} alt="foto" className="img-fluid"/>
                    </a>
                </div>);
            })}
            
        </div>
        </section>);
    } else {
        <p>Loading photos...</p>
        return null;
       
    }
   
}